import React from 'react';
import { colours } from 'styling/colours';
import { style } from 'typestyle';
import { getValueSafely } from 'utils/utils';

export default function AssetStatusCell({ value }: { value: string | undefined }) {
  const hasStatus = value !== null && value !== undefined;

  return (
    <span className={hasStatus ? '' : statusStyle}>
      {hasStatus ? getValueSafely(value) : 'No status set'}
    </span>
  );
}

const statusStyle = style({
  color: colours.secondaryText,
  fontStyle: "italic"
});